<template>
  <div class="wrap">
    <div class="personalTop">
      <van-icon name="arrow-left" color="#fff" size="30" @click="$router.go(-1)" />
      <div style="text-align: center;color: white;height: 30px;">邀请好友</div>
    </div>
    <div class="codeWrap">
      <div class="inviteCode">邀请码:{{uuid}}</div>
      <div id="qrcode"></div>
    </div>
    <button class="btn" id="copyBtn" :data-clipboard-text="inviteUrl">邀请好友获取资格</button>
  </div>
</template>

<script>
  import QRCode from "qrcodejs2";
  import Clipboard from "clipboard";
  export default {
    data() {
      return {
        uuid: "",
        inviteUrl: ""
      };
    },
    mounted() {
      let that=this;
      this.$toast.loading({
        duration: 3000,
        message: "加载中...",
        mask: true
      });
      this.uuid = this.$route.query.uuid;
      this.inviteUrl = `http://${window.location.host}/h5/#/register?uuid=${this.uuid}`;
      this.qrcode();
      const clipboard = new Clipboard("#copyBtn");
      clipboard.on("success", function (e) {
        e.clearSelection();
        that.$toast("注册地址已复制，快去分享吧");
      });
    },
    methods: {
      qrcode() {
        let that = this;
        let qrcode = new QRCode(document.getElementById("qrcode"), {
          width: 162,
          height: 162, // 高度  [图片上传失败...(image-9ad77b-1525851843730)]
          text: that.inviteUrl // 二维码内容
        });
      },

    }
  };
</script>
<style lang='less' scoped>
  .wrap {
    height: 100vh;
    background: url(../../assets/imgs/personal/inviteBg.png) 0 0 no-repeat;
    background-size: 100% 100%;

    .van-icon {
      text-align: center;
      border-radius: 50%;
      position: absolute;
      left: 8px;
      top: 15px;
    }

    .btn {
      width: 205px;
      height: 35px;
      line-height: 35px;
      color: #3E6AFB;
      border: none;
      background: #fff;
      margin: 400px auto 0;
      font-size: 18px;
      display: block;
      border-radius: 17.25px;
    }

    .personalTop {
      width: 100%;
      box-sizing: border-box;
      font-size: 18px;
      color: #333;
      padding-top: 15px;
    }

    #qrcode {
      position: absolute;
      z-index: 10;
      left: 50%;
      top: 30.5%;
      transform: translateX(-50%);
      width: 162px;
      height: 162px;

      img {
        width: 162px;
        height: 162px;
      }
    }

    .inviteCode {
      position: absolute;
      z-index: 10;
      left: 50%;
      transform: translateX(-50%);
      color: #333;
      font-size: 18px;
      border-radius: 20px;
      width: 177.5px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      top: 45%;
    }
  }
</style>